<template>
  <div class="d-flex flex-grow-1">
    <top-app-bar></top-app-bar>
    <v-container fluid class="mx-1">
      <v-row class="pt-16">
        <v-col cols="3">
          <left-nav-bar></left-nav-bar>
        </v-col>
        <v-col cols="9">
          <v-main>
            <v-container class="fill-height pa-0 ma-0" fluid>
              <v-layout>
                <slot></slot>
              </v-layout>
            </v-container>
          </v-main>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import TopAppBar from '@/components/TopAppBar';
  import LeftNavBar from '../components/LeftNavBar.vue';

  import { mapState } from 'vuex';

  export default {
    components: {
      TopAppBar,
      LeftNavBar
    },
    data() {
      return {};
    },
    computed: {
      ...mapState(['app'])
    },
    mounted: function () {
      if (this.app.useAuthentication) {
        this.$store.dispatch('app/getUser').then(() => {
          this.$store.dispatch('admin/getSystemList');
          this.$store.dispatch('admin/getProductTypeList');
          this.$store.dispatch('admin/getProductList');
          this.$store.dispatch('admin/getAttributeList');
          this.$store.dispatch('admin/getControlTypeList');
          this.$store.dispatch('admin/getRequirementTypeList');
          this.$store.dispatch('admin/getRequirementEntityList');
          this.$store.dispatch('admin/getSellAsTypeList');
          this.$store.dispatch('admin/getUserTypeList');
          this.$store.dispatch('admin/getUserList');
        });
      } else {
        this.$store.dispatch('admin/getSystemList');
        this.$store.dispatch('admin/getProductTypeList');
        this.$store.dispatch('admin/getProductList');
        this.$store.dispatch('admin/getAttributeList');
        this.$store.dispatch('admin/getControlTypeList');
        this.$store.dispatch('admin/getRequirementTypeList');
        this.$store.dispatch('admin/getRequirementEntityList');
        this.$store.dispatch('admin/getSellAsTypeList');
        this.$store.dispatch('admin/getUserTypeList');
        this.$store.dispatch('admin/getUserList');
      }
    },
    methods: {
      /**
       * Returns background class based on theme
       */
      getBackground() {
        return this.app.dark ? 'darkBackground' : 'lightBackground';
      }
    }
  };
</script>

<style>
  .v-data-table > .v-data-table__wrapper > table {
    cursor: pointer;
  }
</style>
